export const number = new Intl.NumberFormat("zh-CN");

export function formatNumber(value: number | null | undefined): string {
  return number.format(value ?? 0);
}

export function formatDate(value: string | null | undefined): string {
  if (!value) return "—";
  return new Intl.DateTimeFormat("zh-CN", {
    month: "short",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit"
  }).format(new Date(value));
}

export function errorMessage(error: unknown): string {
  if (error instanceof Error) return error.message;
  return "发生了未知错误";
}

export const analysisLabel: Record<string, string> = {
  not_started: "尚未分析",
  queued: "等待分析",
  running: "正在分析",
  completed: "分析完成",
  failed: "分析失败"
};

export const vocabStatusLabel: Record<string, string> = {
  unknown: "生词",
  seen: "见过",
  learning: "学习中",
  probably_known: "大概认识",
  known_receptive: "阅读认识",
  known_productive: "可主动使用",
  ignored: "忽略",
  unrated: "未判断"
};
